module.exports = __webpack_public_path__ + "img/contenedor19.0735d904.png";